module.exports = __webpack_public_path__ + "img/mi-settings.d5b3bfbb.svg";